var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomSwoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 548 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.0.0-gift-confirmation-with-message-desktop",
    transform: "translate(-444.000000, -644.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gift-Card-Email---With-Message",
    transform: "translate(443.000000, 384.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,285.647369 C63.6788368,268.184769 120.230582,259.453469 169.655234,259.453469 C243.792214,259.453469 337.722069,279.529395 417.237753,281.463621 C470.248209,282.753105 513.835625,275.416387 548,259.453469 L548,303.473773 L0,303.473773 L0,285.647369 Z",
    id: "bottom-swoop"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomSwoop);
export default __webpack_public_path__ + "static/media/bottom-swoop.4f0ac648c2b0751e0b23565bd32183e0.svg";
export { ForwardRef as ReactComponent };